class RegionFilter {

  static init = (params) => {
    const selFilter = `${params.selFilter}:not(.has-filter)`;
    const allFilters = document.querySelectorAll(selFilter);

    allFilters.forEach(filter => {
      new RegionFilter(filter, params)
    })
  }



  constructor(filter, params) {
    this.filter = filter;
    this.filterSelect = this.filter.querySelector(params.selFilterSelect);
    this.filterList = this.filter.querySelector(params.selFilterList);
    this.selFilterItem = params.selFilterItem;
    this.selFilterLink = params.selFilterLink;

    this.itemList = [];
    this.filterLinkList = [];
    this.hiddenItems = [];

    this.createItemList();
    this.createFilterLinkList();
    this.startListening();
  }



  markInitialized = () => {
    this.filter.classList.add('has-filter');
  }



  createItemList = () => {
    const allItems = this.filter.querySelectorAll(this.selFilterItem);
    allItems.forEach(item => {
      this.itemList.push({ item: item, region: item.dataset.region });
    })
  }



  createFilterLinkList = () => {
    this.filterLinkList = this.filter.querySelectorAll(this.selFilterLink);
  }



  startListening = () => {
    this.filterSelect.addEventListener('change', e => {
      this.setHiddenItems(e.target.value);
      this.resetFilter();
      this.applyFilter();
    });

    this.filterList.addEventListener('click', e => {
      if (e.target.matches(this.selFilterLink)) {
        this.resetFilterLinks();
        this.activateFilterLink(e.target);
        this.setHiddenItems(e.target.dataset.region);
        this.resetFilter();
        this.applyFilter();
      }
    });
  }



  resetFilterLinks = () => {
    this.filterLinkList.forEach(link => {
      link.classList.remove('is-active');
    })
  }



  activateFilterLink = (link) => {
    link.classList.add('is-active');
  }



  setHiddenItems = (value) => {

    if (value === '-1') {
      this.hiddenItems = [];
      return;
    }

    this.hiddenItems =
      this.itemList.filter((entry) => entry.region !== value);
  }



  applyFilter = () => {
    this.hiddenItems.forEach(entry => {
      entry.item.style.display = 'none';
      entry.item.tabIndex = -1;
    })
  }



  resetFilter = () => {
    this.itemList.forEach(entry => {
      entry.item.style.display = 'grid';
      entry.item.tabIndex = 0;
    })
  }
}